<template>
  <section class="" style="background: #F6F6F6;color:black">
    <div class="container ">
      <div class="section-title page-title">

        <div class="row m-0">
          <div class="col-12">
            <div class="content text-center">

              <ContentsCapitalLabel
                isSecondaryColor="true"
                label="DESIGN, FUNCTIONAL REQUIREMENT, SIMULATION, PROTOTYPING, VALIDATION"
              />
      
              <h2 class="title h2-caslon text-black text-center f-44 fw-600">CO2 Calculation & Visualization Service by Zero Board</h2>
            </div>

            <div class="content">
              <h2 class="underconstruction-text text-primary text-center">Under Construction</h2>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'CO2 Calculation & Visualization Service by Zero Board - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.page-title {
  padding: 50px 0 0;
}
.page-title .title {
  margin: 40px 0 30px;
}
.page-title .underconstruction-text {
  font-family: 'Myriad-Pro', sans-serif;
  font-weight: 400;
  font-size: 44px;

  margin-bottom: 25px;
}
</style>